var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTrashSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 24,
  fill: "currentColor",
  "aria-hidden": "true",
  viewBox: "0 0 22 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M6.5 2.25A2.25 2.25 0 0 1 8.75 0h4.5a2.25 2.25 0 0 1 2.25 2.25V3h5.25a.75.75 0 0 1 0 1.5H1.25a.75.75 0 0 1 0-1.5H6.5zm7.5 0V3H8v-.75a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.497 6.682a.75.75 0 1 0-1.494.136l1.438 15.818A1.5 1.5 0 0 0 4.935 24h12.13a1.5 1.5 0 0 0 1.494-1.364l1.438-15.818a.75.75 0 1 0-1.494-.136L17.065 22.5H4.935z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.5 8.25V19.5H8V8.25zM14 19.5V8.25h-1.5V19.5z"
})));
export default SvgTrashSmall;